export default "__VITE_ASSET__yyfkNdh4__"